/* JCKED free gifts. The cart is the source of truth: after every cart change this works out which gifts the cart has
   earned and makes the gift lines match. Gifts are ordinary cart lines tagged with the hidden property _jx_gift, priced
   $0 by the automatic discounts set up in Shopify admin (see JCKED-HANDOFF.md).

   Rule: every eligible bottle on a subscription counts toward the bottle total; one-time bottles earn no gifts
   (the JCKED Discounts app applies the same rule at checkout).
   Each gift unlocks at its own minimum (theme settings > JCKED free gifts).
   Exception: the one-time offer pages tag their bottles _jx_once; those one-time bottles unlock the one-time offer gift
   (cfg.once) at its own minimum.
   Split test: a cart with the attribute _jx_gift_track = "monthly" (set by a buy box with Gift set "Monthly gifts")
   earns cfg.giftsMonthly instead of cfg.gifts. */
(function () {
  if (window.__jxGifts) return;
  var el = document.getElementById('jx-gifts-config');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
  cfg.gifts = cfg.gifts || [];
  cfg.giftsMonthly = cfg.giftsMonthly || [];
  if (!cfg.gifts.length && !cfg.giftsMonthly.length && !cfg.once) return;
  window.__jxGifts = true;

  var eligible = {};
  cfg.eligible.forEach(function (id) { eligible[id] = true; });

  var running = false;
  var again = false;
  var timer = null;

  function isGift(line) { return !!(line.properties && line.properties._jx_gift); }

  /* The gift set this cart earns: the split-test monthly set, or the regular one */
  function giftSet(cart) {
    return cart.attributes && cart.attributes._jx_gift_track === 'monthly' ? cfg.giftsMonthly : cfg.gifts;
  }

  /* Bottles that earn gifts: eligible products, however they are bought. */
  function earnedQty(cart) {
    var qty = 0;
    cart.items.forEach(function (line) {
      if (!isGift(line) && eligible[line.product_id] && line.selling_plan_allocation) qty += line.quantity;
    });
    return qty;
  }

  /* One-time offer bottles: eligible, one-time, tagged _jx_once by the one-time offer buy box. */
  function onceQty(cart) {
    var qty = 0;
    cart.items.forEach(function (line) {
      if (!isGift(line) && eligible[line.product_id] && !line.selling_plan_allocation && line.properties && line.properties._jx_once) qty += line.quantity;
    });
    return qty;
  }

  /* Gifts ride on the subscription plan only when the bottles that earned them are on one. */
  function hasSubscription(cart) {
    return cart.items.some(function (line) { return !isGift(line) && eligible[line.product_id] && !!line.selling_plan_allocation; });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); });
  }

  function reconcile() {
    if (running) { again = true; return Promise.resolve(); }
    running = true;
    return fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qty = earnedQty(cart);
        var sub = hasSubscription(cart);
        var want = {};
        giftSet(cart).forEach(function (g) { if (g.available && qty >= g.min) want[g.variant] = g; });
        if (cfg.once && cfg.once.available && !want[cfg.once.variant] && onceQty(cart) >= cfg.once.min) want[cfg.once.variant] = cfg.once;

        var updates = {};
        var have = {};
        var changed = false;
        cart.items.forEach(function (line) {
          if (!isGift(line)) return;
          var keep = want[line.variant_id] && !have[line.variant_id];
          if (keep) {
            have[line.variant_id] = true;
            if (line.quantity !== 1) { updates[line.key] = 1; changed = true; }
          } else {
            updates[line.key] = 0; // gift no longer earned, or a duplicate line
            changed = true;
          }
        });

        var toAdd = [];
        Object.keys(want).forEach(function (variantId) {
          if (have[variantId]) return;
          var g = want[variantId];
          var item = { id: g.variant, quantity: 1, properties: { _jx_gift: '1' } };
          if (g.plan && sub) item.selling_plan = g.plan;
          toAdd.push(item);
        });

        var chain = Promise.resolve();
        if (Object.keys(updates).length) chain = chain.then(function () { return post('/cart/update.js', { updates: updates }); });
        if (toAdd.length) {
          chain = chain.then(function () { return post('/cart/add.js', { items: toAdd }); }).then(function (res) {
            if (res && !res.ok) console.warn('[JCKED gifts] could not add a gift:', res.json && (res.json.description || res.json.message));
            changed = true;
          });
        }
        return chain.then(function () { return changed; });
      })
      .then(function (changed) {
        if (!changed) return;
        /* The /cart page has no drawer to redraw: refresh it so the new gift lines show. */
        if (document.getElementById('main-cart-items')) { window.location.reload(); return; }
        if (typeof window.jxCartRedraw === 'function') return window.jxCartRedraw();
      })
      .catch(function () { /* network hiccup: the next cart change reconciles again */ })
      .then(function () {
        running = false;
        if (again) { again = false; schedule(0); }
      });
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(reconcile, delay);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { schedule(120); });
  }
  /* Also settle once on load (e.g. the cart was changed in another tab). */
  schedule(600);
})();
